import _ from "lodash";
import { JsTimeSpan } from "../../../ViewModel/JsTimeSpan";
import { LtlRoutingViewModel } from "../../../ViewModel/LtlRoutingViewModel";

function round(x: number, n: number) {
  const a = 10 ** n;
  return Math.round(x * a) / a;
}

export function getSupplierTransitTime(
  routing: LtlRoutingViewModel[] | undefined,
  ttAdjustment: number | undefined
) {
  if (!routing || routing.length < 1) {
    return 0;
  }

  const index = routing.length - 1;
  let arrivalTime: JsTimeSpan | undefined;
  if (routing[index] && routing[index].ArrivalTime) {
    arrivalTime = routing[index].ArrivalTime;
  }
  if (!arrivalTime) {
    return 0;
  }

  if (_.isString(arrivalTime.Hours)) {
    arrivalTime.Hours = parseInt(arrivalTime.Hours, 10);
  }

  if (_.isString(arrivalTime.Minutes)) {
    arrivalTime.Minutes = parseInt(arrivalTime.Minutes, 10);
  }

  const fullDayTT = routing[index].ArrivalDay;
  arrivalTime.TotalMinutes = arrivalTime.Hours! * 60 + arrivalTime.Minutes!;
  const y = arrivalTime.TotalMinutes / (24 * 60) - 0.25 + 0.083 + fullDayTT!;

  let x = 0.0;
  if (y > 0) {
    x = round(y, 2);
  } else {
    x = round(y, 2) + 1;
  }

  if (
    !(
      ttAdjustment === undefined ||
      ttAdjustment === null ||
      Number.isNaN(ttAdjustment)
    )
  ) {
    if (_.isString(ttAdjustment)) {
      ttAdjustment = parseFloat(ttAdjustment);
    }
    x += ttAdjustment;
  }

  x = round(x, 2);

  return x;
}
